















import {Component, Prop, Vue} from 'vue-property-decorator';
import {DisplayOption} from './interfaces/ComponentOptions';

@Component
export default class DropdownButton extends Vue {
    @Prop({type: Array, required: true})
    private items!: DisplayOption[];
    @Prop({type: Boolean, required: false, default: false})
    private disabled!: boolean;
    @Prop({type: Boolean, required: false, default: false})
    private alignLeft!: boolean;
    @Prop({type: String, required: false, default: ""})
    private css!: string;
    @Prop({type: String, required: false, default: ""})
    private buttonCss!: string;
    @Prop({type: String, required: false, default: ""})
    private dropdownCss!: string;

    private showActionDropdown = false;

    toggleDropdown() {
        if (!this.disabled) {
            this.showActionDropdown = !this.showActionDropdown;
        }
    }

    itemClicked(id: number) {
        if (!this.disabled) {
            this.$emit('dropdown-selected', id);
            this.showActionDropdown = false;
        }
    }
}
